import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'stroke-straight', 'StrokeStraight', [["path",{"d":"M4 19l16 -14","key":"svg-0"}]]);